const key = { up: 38, down: 40, enter: 13, esc: 27, tab: 9, shift: 16 };
const $ = require('jquery');
const _ = require('lodash');

module.exports = function ($timeout, $document, moveFocus) {
    return {
        restrict: 'E',
        scope: {
            inputText: '=inputToBind',
            inputId: '@',
            inputType: '@?',
            onEnter: '&',
            onSelect: '&?',
            onType: '&',
            onInputFocus: '&?',
            onFocusLost: '&?',
            autocompleteList: '=autocompleteList',
            inputClass: '@?',
            listClass: '@?autocompleteListClass',
            ulClass: '@?',
            labelText: '@',
            placeholder: '@?',
            includeSearchIcon: '=',
            template: '@?',
            clearActions: '&?',
            errorMessage: '=errorMessage',
            initialValue: '@?',
            containerClass: '@?',
            source: '@?',
            keywordLength: '@',
            showListAfterSelected: '@',
            name: '@',
            validationError: '@?',
            isValid: '=?',
            debounce: '=?',
            customTemplate: '@',
            trackBy: '@?',
            closeOverlay: '&?',
            required: '<?'
        },
        link: {
            post(scope, element, attrs) {
                let lastInputValue = '';
                let isSelectedText = false;
                let pendingSugguestion = 0;
                let isPendingEnterPressed = false;

                const keywordLength = scope.keywordLength ? parseInt(scope.keywordLength, 10) : 1;

                scope.selectedIndex = 0;
                scope.isFocused = false;
                scope.inputType = scope.inputType || 'text';

                if (!scope.name) {
                    scope.name = 'autoComplete';
                }

                if (!scope.debounce) {
                    scope.debounce = 0;
                }

                if (scope.errorMessage) {
                    scope.$watch('errorMessage', function () {
                        scope.setErrorMessage();
                    });
                }

                // Default autocomplete selection.
                function selectOption(optionValue) {
                    scope.endPopulateSuggestion = true;
                    scope.updateInputText(optionValue);

                    $timeout(function () { scope.onEnter(); });

                    if (scope.template.length === 0) {
                        scope.clear();
                    }
                }

                function isListEmpty() {
                    return scope.autocompleteList.length <= 0;
                }

                function onFocusLost(isFocusLostFn) {
                    $timeout(() => {
                        if (isFocusLostFn($document[0].activeElement)) {
                            return;
                        }
                        if (attrs.onFocusLost) {
                            scope.isFocused = false;
                            scope.onFocusLost();
                        }
                    }, 0);
                }

                function performEnterKey() {
                    if (scope.selectedIndex >= 0) {
                        let selectedOption;
                        if (scope.customTemplate === 'true') {
                            selectedOption = element.find('._autocompleteLink').eq(scope.selectedIndex).data('id');
                        } else {
                            selectedOption = scope.autocompleteList[scope.selectedIndex];
                        }

                        if (scope.template.length === 0) {
                            selectOption(selectedOption);
                        } else {
                            scope.optionSelect(selectedOption);
                            scope.clear();
                        }
                    } else {
                        const selectedOption = scope.autocompleteList[0];
                        scope.optionSelect(selectedOption);
                        scope.clear();
                    }

                    isPendingEnterPressed = false;
                }

                scope.updateStatusMessage = function (message) {
                    scope.statusMessage = message;
                };

                scope.$watch('autocompleteList', function () {
                    if (lastInputValue !== scope.inputText) {
                        scope.selectedIndex = 0;
                    }
                    const message = scope.autocompleteList.length > 0 ? scope.autocompleteList.length + ' suggestions match your input, use up and down arrow keys to navigate.' : '';
                    scope.updateStatusMessage(message);
                });

                scope.hasInputValue = function () {
                    return (scope.inputText !== undefined && scope.inputText.length > 0);
                };

                scope.hasListOfOptions = function () {
                    return (scope.autocompleteList !== undefined && scope.autocompleteList.length > 0);
                };

                scope.clear = function () {
                    scope.autocompleteList = [];
                    lastInputValue = '';
                    scope.selectedIndex = 0;
                    scope.showErrorMessage = false;
                };

                scope._init = function () {
                    scope.endPopulateSuggestion = false;
                    scope.clear();
                    scope.inputText = scope.initialValue || '';
                };

                scope.isSelectedInput = function () {
                    const $activeElement = document.activeElement;
                    return $activeElement.id === scope.inputId || $activeElement.id === scope.inputId + '-clear';
                };

                scope.setIndex = function (position) {
                    scope.selectedIndex = position;
                };

                scope.inputClasses = function () {
                    const classes = {
                        'olyAutocomplete-inputField': true
                    };
                    if (scope.inputClass) {
                        classes[scope.inputClass] = true;
                    }
                    return classes;
                };

                scope.listClasses = function () {
                    const classes = {
                        'is-active': scope.autocompleteList && scope.autocompleteList.length
                    };
                    if (scope.listClass) {
                        classes[scope.listClass] = true;
                    }
                    return classes;
                };

                scope.updateInputText = function (textToShow) {
                    scope.inputText = textToShow;
                };

                scope.updateSelectedItemStyles = function (position) {
                    const links = element.find('._autocompleteLink');
                    $(links).removeClass('is-hovered');
                    $(links[position]).addClass('is-hovered');
                };

                scope.updateSelectedOption = function (position) {
                    scope.setIndex(position);
                    const optionText = element.find('._autocompleteLink').eq(position).text().trim();
                    scope.updateStatusMessage(optionText);
                    scope.updateSelectedItemStyles(position);
                };

                scope.scrollList = function (selectedOption, direction) {
                    const selectedOptionEl = element.find('._autocompleteLink').eq(selectedOption);
                    const selectedOptionOffsetTop = selectedOptionEl.position().top;
                    const selectedOptionHeight = selectedOptionEl.innerHeight();
                    const scrollEl = selectedOptionEl.closest('.hideScroll-wrapper');
                    const prevScroll = scrollEl.scrollTop();
                    if (direction === 'down') {
                        // Scroll down to selected option when it is partially hidden.
                        if (selectedOptionOffsetTop + selectedOptionHeight >= scrollEl.height()) {
                            scrollEl.scrollTop(prevScroll + selectedOptionHeight);
                        }
                    } else {
                        // Scroll up to selected option when it is partially hidden.
                        if (selectedOptionOffsetTop <= prevScroll) {
                            scrollEl.scrollTop(prevScroll - selectedOptionHeight);
                        }
                    }
                };

                scope.moveDown = function () {
                    const listLength = element.find('._autocompleteLink').length;
                    if (scope.selectedIndex === listLength - 1) {
                        return;
                    }
                    const nextPosition = scope.selectedIndex + 1;
                    scope.updateSelectedOption(nextPosition);
                    scope.scrollList(nextPosition, 'down');
                };

                scope.moveUp = function () {
                    if (scope.selectedIndex === 0) {
                        return;
                    }
                    const nextPosition = scope.selectedIndex - 1;
                    scope.updateSelectedOption(nextPosition);
                    scope.scrollList(nextPosition, 'up');
                };

                scope.onTab = function (event) {
                    const keypressed = event.keyCode || event.which;
                    if (keypressed === key.tab && !event.shiftKey) {
                        scope.clear();
                    }
                };

                scope.searchTermFocus = function () {
                    scope.isFocused = true;
                    if (attrs.onInputFocus) {
                        scope.onInputFocus();
                    }
                };

                scope.clearButtonFocusLost = onFocusLost.bind(undefined, (el) => {
                    return el.id === scope.inputId;
                });

                scope.handleKeyPressed = function (event) {
                    const keyPressed = event.keyCode || event.which;
                    // Ignore the shift and tab keys for accessibility
                    if (keyPressed === key.tab || keyPressed === key.shift) {
                        return;
                    }

                    scope.endPopulateSuggestion = false;

                    switch (keyPressed) {
                        case key.down:
                            if (isListEmpty()) {
                                break;
                            }
                            event.preventDefault();

                            if (scope.selectedIndex < 0) {
                                //focus on first item on the list
                                scope.updateSelectedOption(0);
                            } else if (scope.selectedIndex >= 0) {
                                scope.moveDown();
                            }

                            break;

                        case key.up:
                            if (isListEmpty()) {
                                break;
                            }
                            event.preventDefault();
                            scope.moveUp();
                            break;

                        case key.esc:
                            scope.clear();
                            scope.endPopulateSuggestion = true;
                            break;

                        case key.enter:
                            if (pendingSugguestion === 0) {
                                performEnterKey();
                            } else {
                                isPendingEnterPressed = true;
                            }

                            event.preventDefault();
                            break;

                        default:
                            isSelectedText = false;
                    }
                };

                scope.populateSuggestions = function () {
                    if (lastInputValue === scope.inputText) {
                        return;
                    }

                    if (scope.endPopulateSuggestion) {
                        return;
                    }

                    if (scope.inputText.length >= keywordLength) {

                        pendingSugguestion++;

                        scope.onType({
                            searchTerm: scope.inputText,
                            // eslint-disable-next-line no-use-before-define
                            fnCallback() {
                                pendingSugguestion--;

                                if (isPendingEnterPressed && pendingSugguestion === 0) {

                                    $timeout(() => { performEnterKey(); }, 0);
                                }
                            }
                        });
                    }

                    if (scope.inputText === '') {
                        scope.clear();
                        return;
                    }

                    lastInputValue = scope.inputText;
                };

                scope.setErrorMessage = function () {
                    if (scope.isSelectedInput() && scope.inputText !== '') {
                        if (scope.errorMessage.Text !== '') {
                            scope.showErrorMessage = true;
                        }
                    } else {
                        scope.showErrorMessage = false;
                    }
                };

                scope.optionSelect = function (optionValue) {
                    if (scope.source) {
                        optionValue.source = scope.source;
                    }
                    if (!scope.showListAfterSelected) {
                        isSelectedText = true;
                    }

                    if (scope.template.length > 0) {
                        scope.onSelect({ option: optionValue });
                    } else {
                        selectOption(optionValue);
                    }
                };

                scope.searchButtonClicked = function ($event) {
                    $event.preventDefault();
                    $event.stopPropagation();
                    scope.onSelect();
                    scope._init();

                    if (typeof scope.closeOverlay === 'function') {
                        scope.closeOverlay();
                    }
                };

                scope.clearInput = function (event) {
                    event.preventDefault();
                    if (scope.clearActions) {
                        scope.clearActions();
                    }
                    scope.inputText = '';
                    scope.clear();
                    moveFocus('#' + scope.inputId + '');
                };

                scope.showAutoCompleteList = function () {
                    if (scope.inputType === 'search') {
                       return true;
                    }
                    return (scope.isFocused && !isSelectedText && scope.isSelectedInput() && scope.autocompleteList.length > 0 && scope.inputText.length > 0);
                };

                scope.$watch('inputText', function (value) {
                    if (value !== undefined) {
                        scope.populateSuggestions();
                    }

                    if (_.trim(value) === '') {
                        if (scope.clearActions) scope.clearActions();
                    }
                });

                scope.$watch('autocompleteList', function (value) {
                    if (value && value.length > 0) {
                        $timeout(() => {
                            scope.updateSelectedItemStyles(0);
                        }, 0);
                    }
                });

                scope.trackByProperty = function (option, $index) {
                    return scope.trackBy ? option[scope.trackBy] : $index;
                };

                scope._init();
            }
        },
        template: require('./autocomplete-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/autocomplete/autocomplete-directive.js
 **/